import { useState, useMemo } from "preact/hooks";
import ActivityReportView from "@/ui/pages/activity_report/activityReportView";
import Logo from "@/ui/components/Logo";
import ContinueInAppInner from "@/ui/components/ContinueInAppInner";
import { getL11nString } from "@/l11n/l11n";

const ContinueInAppModal = ({ assessment }) => {
  const [showReport, setShowReport] = useState(false);

  // MARK: Local L11N
  const strings = useMemo(
    () => ({
      get_app: getL11nString("get_app"),
      get_app_end_of_report: getL11nString("get_app_end_of_report"),
      view_report: getL11nString("view_report"),
    }),
    []
  );

  const handleViewReportClick = (e) => {
    e.preventDefault();
    setShowReport(true);
  };

  // MARK: Render
  if (showReport) {
    return <ActivityReportView assessment={assessment} />;
  }

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="flex flex-col items-center text-center p-4">
        <div className="mb-6">
          <Logo />
        </div>
        <ContinueInAppInner />
        {assessment && (
          <div className="mt-4">
            <button
              className="text-lg bg-blue-500 hover:bg-blue-600 text-white font-medium py-2 px-4 rounded-md transition-colors duration-200"
              onClick={handleViewReportClick}
            >
              {strings.view_report}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ContinueInAppModal;
